import { render, staticRenderFns } from "./news6.vue?vue&type=template&id=7ed611dd&scoped=true&"
import script from "./news6.vue?vue&type=script&lang=js&"
export * from "./news6.vue?vue&type=script&lang=js&"
import style0 from "./news6.vue?vue&type=style&index=0&id=7ed611dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed611dd",
  null
  
)

export default component.exports